export default [
//   {

//   path: '/clients',
//   redirect: 'clients'
// },
// Rutas ocultas/inaccesibles temporalmente (reversible: descomentar para restaurar).
// {
//   path: '/clients',
//   name: 'clients',
//   component: () => import(/* webpackChunkName: "clients" */ '@/pages/client/ClientsPage.vue'),
//   meta: { requiresAuth: true }
// },
// {
//   path: '/clients/edit',
//   name: 'client-edit',
//   component: () => import(/* webpackChunkName: "client-edit" */ '@/pages/client/EditClientPage.vue'),
//   meta: { requiresAuth: true }
// }
]
